/**
 * Massage shops: 轮钟 rotation board, 点钟 requested therapist (fee / bonus), report + settings.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts + en/zh/ms.ts.
 */
const ROWS = [
  ["rot.nav","Rotation board","轮钟"],
  ["rot.tab","Rotation","轮钟"],
  ["rot.title","Rotation board (轮钟)","轮钟排班"],
  ["rot.intro","Therapists join the queue when they clock in and leave when they clock out. “Assign next” gives a walk-in to the first free therapist in turn.","技师打卡上班后自动排入队列，下班自动离开。点「派下一位」把客人交给轮到的空闲技师。"],
  ["rot.tabs.board","Board","轮钟"],
  ["rot.tabs.report","Report","统计"],
  ["rot.tabs.settings","Settings","设置"],
  ["rot.mode.tail","Finished turns go to the back","做完排到队尾"],
  ["rot.mode.count","Fewest turns first","钟数少者优先"],
  ["rot.assignNext","Assign next","派下一位"],
  ["rot.assignTitle","Assign the next therapist","派下一位技师"],
  ["rot.requestTitle","Customer asks for {name} (点钟)","客人点钟：{name}"],
  ["rot.service","Service","服务"],
  ["rot.noService","Choose later","稍后再选"],
  ["rot.openSale","Open a sale for this customer","同时开单"],
  ["rot.assignGo","Assign","派钟"],
  ["rot.assigned","{name} takes this customer.","已派给 {name}。"],
  ["rot.saleFailed","Assigned to {name}, but the sale couldn't be opened: {reason}","已派给 {name}，但开单失败：{reason}"],
  ["rot.next","Next up","下一位"],
  ["rot.status.idle","Free","空闲"],
  ["rot.status.busy","With a customer","上钟中"],
  ["rot.status.paused","Paused","暂停"],
  ["rot.status.break","On a break","休息中"],
  ["rot.turns","{n} turns","{n} 轮"],
  ["rot.requests","{n} requested","点钟 {n}"],
  ["rot.requested","点钟 Requested","点钟"],
  ["rot.rotationJob","Rotation turn","轮钟"],
  ["rot.left","{n} min left","剩 {n} 分钟"],
  ["rot.over","{n} min over","超时 {n} 分钟"],
  ["rot.toTail","goes to the back when done","完成后排到队尾"],
  ["rot.keepPlace","keeps the place when done","完成后保留原位"],
  ["rot.done","Done","完成"],
  ["rot.cancelJob","Didn't happen","取消此钟"],
  ["rot.openSaleBtn","Open sale","打开订单"],
  ["rot.requestBtn","点钟","点钟"],
  ["rot.requestBtnHint","Customer asks for this therapist","客人指定这位技师"],
  ["rot.pause","Pause","暂停"],
  ["rot.resume","Resume","恢复"],
  ["rot.remove","Take off","移出"],
  ["rot.removeConfirm","Take {name} off today's board?","把 {name} 移出今天的队列？"],
  ["rot.moveUp","Move up","上移"],
  ["rot.moveDown","Move down","下移"],
  ["rot.dragHint","Managers can drag a card (or use ↑ ↓) to change the order.","店长可拖动卡片（或用 ↑ ↓）调整顺序。"],
  ["rot.add","Add to board","加入队列"],
  ["rot.addPick","Add a therapist…","加入技师…"],
  ["rot.empty","Nobody on the board yet. Therapists appear here when they clock in; a manager can also add them.","队列还没有人。技师打卡后会出现在这里，店长也可以手动加入。"],
  ["rot.nobodyFree","Nobody is free right now.","现在没有空闲的技师。"],
  ["rot.history","Today's log","今日记录"],
  ["rot.ev.join","{name} joined the queue","{name} 加入队列"],
  ["rot.ev.leave","{name} clocked out","{name} 下班离开队列"],
  ["rot.ev.add","{name} added","{name} 被加入队列"],
  ["rot.ev.remove","{name} taken off","{name} 被移出队列"],
  ["rot.ev.pause","{name} paused","{name} 暂停"],
  ["rot.ev.resume","{name} resumed","{name} 恢复"],
  ["rot.ev.reorder","Queue order changed","队列顺序已调整"],
  ["rot.ev.turn","{name} took a rotation turn","{name} 轮钟上钟"],
  ["rot.ev.request","{name} was requested (点钟)","{name} 被点钟"],
  ["rot.ev.done","{name} finished","{name} 完成"],
  ["rot.ev.cancel","{name}'s job was cancelled","{name} 的钟已取消"],
  ["rot.ev.settings","Settings changed","设置已更改"],
  ["rot.ev.by","by {actor}","操作人 {actor}"],
  ["rot.set.title","Rotation & requests (轮钟与点钟)","轮钟与点钟"],
  ["rot.set.intro","Massage shops: how the turn queue works, and the fee and bonus when a customer asks for a specific therapist (点钟).","按摩店专用：轮钟规则，以及客人指定技师（点钟）时的加收费用与技师加成。"],
  ["rot.set.mode","Queue order","轮钟方式"],
  ["rot.set.modeTail","A finished turn goes to the back of the queue","做完一钟排到队尾"],
  ["rot.set.modeCount","Whoever has the fewest turns today goes first","今天钟数少的技师优先"],
  ["rot.set.counts","A requested job also uses up the therapist's turn (点钟也算一轮)","点钟也算一轮（做完同样排到队尾）"],
  ["rot.set.fee","Request fee (点钟费) added to the bill","点钟费（加到账单）"],
  ["rot.set.feeHint","Per requested service, taxed like the service. 0 = no fee.","每个点钟服务加收，与服务一样计税。0 = 不加收。"],
  ["rot.set.bonus","Request bonus (点钟加成) for the therapist","点钟加成（给技师）"],
  ["rot.set.bonusHint","Fixed amount per requested service, paid through commission and payroll. A commission rule “Request bonus” for a service, category or level overrides it.","每个点钟服务的固定金额，计入提成和工资。提成方案里针对服务、类别或级别的「点钟加成」规则优先。"],
  ["rot.set.minutes","Busy time when the service length is unknown (minutes)","服务时长未知时占用时间（分钟）"],
  ["rot.set.save","Save","保存"],
  ["rot.set.saved","Saved.","已保存。"],
  ["rot.rep.title","Turns and requests per therapist","技师轮钟与点钟统计"],
  ["rot.rep.from","From","从"],
  ["rot.rep.to","To","到"],
  ["rot.rep.group","Per","按"],
  ["rot.rep.day","Day","日"],
  ["rot.rep.month","Month","月"],
  ["rot.rep.period","Date","日期"],
  ["rot.rep.staff","Therapist","技师"],
  ["rot.rep.turns","Rotation turns","轮钟"],
  ["rot.rep.requests","Requested (点钟)","点钟"],
  ["rot.rep.fee","Request fee collected","点钟费收入"],
  ["rot.rep.bonus","Request bonus","点钟加成"],
  ["rot.rep.total","Total","合计"],
  ["rot.rep.csv","Download CSV","下载 CSV"],
  ["rot.rep.empty","No turns or requests in this period.","这段时间没有轮钟或点钟记录。"],
  ["rot.pos.requested","点钟","点钟"],
  ["rot.pos.requestedHint","Customer asked for this therapist","客人指定这位技师"],
  ["rot.pos.board","Rotation","轮钟"],
  ["rot.appt.requested","Customer asked for this therapist (点钟)","客人指定这位技师（点钟）"],
  ["rot.appt.anyone","“Anyone” bookings go to the next therapist in turn at check-in.","不指定技师的预约，到店签到时按轮钟派给下一位。"],
  ["payroll.type.request_bonus","Request bonus (点钟加成)","点钟加成"],
] as const;

export type RotKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[1 + (i - 1)] ])) as Record<RotKey, string>;

export const taskROT = { en: col(1), zh: col(2), ms: col(1) };
